import styled, { css } from 'styled-components'
import { Dropdown } from 'common-components/Dropdown'
import { COLORS } from 'consts/colors'
import { MOBILE_HEADER_HEIGHT } from 'consts'

export const SearchableDropdownWrapper = styled.div<{
  $isLoading?: boolean
}>`
  height: 100%;
  width: 100%;
  flex-shrink: 0;

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      background-color: ${COLORS.primaryExtraLight};
      border-radius: 5px;
    `}
`

export const SearchableDropdownContent = styled(Dropdown)`
  width: 100%;
  height: 100%;
`

export const TabletView = styled.div`
  height: calc(100dvh - ${MOBILE_HEADER_HEIGHT}px);
  display: flex;
  flex-direction: column;
  padding: 16px;
`
